// The browser <html> element default font size is 16px, but browsers have an option to change this value, so rem
// units allow us to accommodate the user's settings, resulting in a better accessibility support. Users change
// font size settings for all kinds of reasons, from poor eyesight to choosing optimum settings for devices that
// can be vastly different in size and viewing distance.
// MUI handles this conversion natively. However, it does not do this for any custom theme variants we add
// so we need to do it manually for our custom font styles. This function should also be used anywhere a
// px unit needs to be converted to a rem unit. This will most often be used for converting px units from
// designs in Figma.
// Do not pass numbers with units, this util function is intended to accept a px number without the 'px' unit
const convertPxToRem = (x) => `${parseFloat((x / 16).toFixed(3))}rem`;
export default convertPxToRem;
